import * as THREE from "three";
import Heatpoint from '../heatpointscontrol/heatpoint'
import gsap from "gsap";

export default class quanTower extends THREE.Object3D {
	constructor(pinColor, pinColorDark, camera, interactionManager, onPinClick, gltfanimations, mixer, model,visitedPinColor) {
		super();

        model.children[127].position.y = -1
        model.children[128].position.y = -1
        model.children[129].position.y = -1
        model.children[130].position.y = -1
        model.children[131].position.y = -1
        model.children[132].position.y = -1
        model.children[133].position.y = -1
        model.children[134].position.y = -1
        
        
        model.children[9].children[1].material.color.setHex(0xd4af37)
        model.children[9].children[1].material.metalness = 0.5
        model.children[9].children[1].material.roughness = 0.5
        model.children[9].children[1].material.needsUpdate = true;
        model.children[9].children[1].geometry.computeVertexNormals();
        model.children[9].children[1].material.flatShading = false;
       
    
		this.pinModel = new Heatpoint(null, "model/heatointquan.glb")
        setTimeout(() => {
            this.pinModel.setColor(pinColor);
        }, 1000);
		this.pinModel.position.set(0.0, 0.60, 0.92);
        this.visited = false;

		interactionManager.add(this.pinModel);

		this.pinModel.addEventListener("click", (event) => {
			onPinClick();
			gsap.to(camera.position, { x: 0.2, y: 0.7, z: 1.8, duration: 2.5, ease: "Power3.inOut" })
            this.visited = true;   
            this.triggerAnimations(gltfanimations, mixer, true, model);
        })
       
		this.pinModel.addEventListener('mouseover', (event) => {
			document.body.style.cursor = 'pointer';
			this.pinModel.setColor(pinColorDark);
		});
		this.pinModel.addEventListener('mouseout', (event) => {
			document.body.style.cursor = 'default';
            if(!this.visited){
                this.pinModel.setColor(pinColor);
            }
            else{
				this.pinModel.setColor(visitedPinColor);
			}
		});
		this.add(this.pinModel)
		
		this.rotationAngle = 0;
    	this.rotatePin();
	}


    triggerAnimations(gltfanimations, mixer, modal, model){
        const modal1 = document.getElementById('modal1');
        const clipActions = [];
        const clipActions3 = [];
        setTimeout(() => {
            const startIndex = 41;
            const endIndex = 48;
            const animations = gltfanimations;
            const actions = [];
            
            for (let i = startIndex; i <= endIndex; i++) {
                const clip = animations[i];
                const action = mixer.clipAction(clip);
                action.setLoop(THREE.LoopOnce);
                actions.push(action);
            }
            actions.forEach(action => {
                action.reset();
                action.timeScale = 1; // Play the animation backwards
                action.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            });
        }, 5000);
        
        
        const animationNames = [    'Quantower.001Action',    'Quantower.002Action',    'Quantower.003Action',    'Quantower.004Action',    'Quantower.005Action',    'Quantower.006Action',    'Quantower.007Action',    'Quantower.008Action',    'Quantower.009Action',    'Quantower.010Action',    'Quantower.011Action',    'Quantower.012Action',    'Quantower.013Action',    'Quantower.014Action'  ];
        
        for (let i = 0; i < animationNames.length; i++) {
            const animation = THREE.AnimationClip.findByName(gltfanimations, animationNames[i]);
            const clipAction = mixer.clipAction(animation);
            clipActions.push(clipAction);
        }
        clipActions.forEach((clip) => {
            clip.reset();
            clip.timeScale = 1;
            clip.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            if(modal){
                setTimeout(() => {
                    modal1.classList.remove('hidden');
                }, 8500);
            }
        });

        setTimeout(() => {
            const animationNames = [ 'Ganze BrückeAction', 'Fahrrad.009Action.003','Fahrrad.009Action.002', 'Fahrrad.009Action.001', 'Cranks.010Action.001'  ];
          
            for (let i = 0; i < animationNames.length; i++) {
                const animation3 = THREE.AnimationClip.findByName(gltfanimations, animationNames[i]);
                const clipAction3 = mixer.clipAction(animation3);
                clipActions3.push(clipAction3);
            }
            clipActions3.forEach((clip) => {
                clip.reset();
                clip.timeScale = 1
                clip.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;							
            });

        }, 6500);

        modal1.addEventListener('click', function() {
            modal1.classList.add('hidden');
            clipActions.forEach((clip) => {
                clip.reset();
                clip.timeScale = -1; // Play the animation backwards
                clip.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
            });
            clipActions3.forEach((clip) => {
                clip.reset();
                clip.timeScale = -1; // Play the animation backwards
                clip.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
        
            });
            const startIndex = 41;
            const endIndex = 48;
            const animations = gltfanimations;
            const actions = [];
    
            for (let i = startIndex; i <= endIndex; i++) {
                const clip = animations[i];
                const action = mixer.clipAction(clip);
                clip.timeScale = -1;
                action.setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
                actions.push(action);
            }
            actions.forEach((clip) => {
                clip.reset();
                clip.timeScale = -1; // Play the animation backwards
                clip.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
        
            });
            setTimeout(() => {
                model.children[127].position.y = -1
                model.children[128].position.y = -1
                model.children[129].position.y = -1
                model.children[130].position.y = -1
                model.children[131].position.y = -1
                model.children[132].position.y = -1
                model.children[133].position.y = -1
                model.children[134].position.y = -1
        }, 1000);
        });	
  

    }
    
    resetAnimations(gltfanimations, mixer, model) {
        const animationNames = [      'Quantower.001Action',      'Quantower.002Action',      'Quantower.003Action',      'Quantower.004Action',      'Quantower.005Action',      'Quantower.006Action',      'Quantower.007Action',      'Quantower.008Action',      'Quantower.009Action',      'Quantower.010Action',      'Quantower.011Action',      'Quantower.012Action',      'Quantower.013Action',      'Quantower.014Action'    ];
        const clipActions = [];
        for (let i = 0; i < animationNames.length; i++) {
        const animation = THREE.AnimationClip.findByName(gltfanimations, animationNames[i]);
        const clipAction = mixer.clipAction(animation);
        clipActions.push(clipAction);
        }
        clipActions.forEach((clip) => {
        if (clip.time > 0) { 
                clip.enabled = false;
            } else {
                clip.reset();
            }
        });
      
        const animationNames2 = ['Ganze BrückeAction', 'Fahrrad.009Action.003','Fahrrad.009Action.002','Fahrrad.009Action.001','Cranks.010Action.001'];
        const clipActions3 = [];
        for (let i = 0; i < animationNames2.length; i++) {
        const animation3 = THREE.AnimationClip.findByName(gltfanimations, animationNames2[i]);
        const clipAction3 = mixer.clipAction(animation3);
        clipActions3.push(clipAction3);
        }
        clipActions3.forEach((clip) => {
            clip.reset();
            clip.timeScale = -1
            clip.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;	
        });

        const startIndex = 23;
        const endIndex = 30;
        const animations = gltfanimations;
        const actions = [];

        for (let i = startIndex; i <= endIndex; i++) {
			const clip = animations[i];
			const action = mixer.clipAction(clip);
			clip.timeScale = -1;
			action.setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
			actions.push(action);
		}
		actions.forEach((clip) => {
			clip.reset();
			clip.timeScale = -1; // Play the animation backwards
			clip.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
	
		});
        setTimeout(() => {
            model.children[127].position.y = -1
            model.children[128].position.y = -1
            model.children[129].position.y = -1
            model.children[130].position.y = -1
            model.children[131].position.y = -1
            model.children[132].position.y = -1
            model.children[133].position.y = -1
            model.children[134].position.y = -1
        }, 1000);
    }

	rotatePin() {
        this.rotationData = { angle: 0 };
        gsap.to(this.rotationData, {
            angle: "+=" + 2 * Math.PI, // Add 360 degrees in radians
            duration: 10, // Define how fast you want a full rotation to be. Here it's set to 5 seconds.
            ease: "none", // Linear rotation
            onUpdate: () => {
                this.pinModel.setRotationFromAxisAngle(new THREE.Vector3(0, 1, 0), this.rotationData.angle);
            },
            repeat: -1 // This will make the animation run indefinitely
        });
	}
}


